import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { roleGuard } from './RoleGuard';
import Login from '../pages/auth/Login';
import PrivateRoutes from './PrivateRoute';
import Index from '../pages/Index';
import ProfileView from '../pages/profile/ProfileView';
import ScheduleView from '../pages/schedule/ScheduleView';
import Register from '../pages/auth/Register';
import RegisterNew from '../pages/auth/RegisterNew';
import RegisterExist from '../pages/auth/RegisterExist';
import AttendanceView from '../pages/schedule/attendance/AttendanceView';
import ResetPassword from '../pages/auth/ResetPassword';
import InboxList from '../pages/inbox/InboxList';
import InboxView from '../pages/inbox/InboxView';
import LoginAsUser from '../pages/login-as-user/LoginAsUser';
import CheckInHistory from '../pages/checkin/CheckInHistory';
import HomeworkList from '../pages/homework/HomeworkList';
import HomeworkAddEdit from '../pages/homework/HomeworkAddEdit';
import HomeworkStudent from '../pages/homework/HomeworkStudent';
// import { academyRoutes } from './AcademyRoute';

const routes: RouteObject[] = [
    { path: "login", element: <Login /> },
    { path: "register", element: <Register /> },
    { path: "register-new", element: <RegisterNew /> },
    { path: "register-exist", element: <RegisterExist /> },
    { path: "reset-password", element: <ResetPassword/> },
    { path: "login-as-user", element: <LoginAsUser/> },
    {
        path: "/",
        loader: roleGuard,
    },
    // ...academyRoutes
    {
        path: "/",
        element: <PrivateRoutes />,
        children: [
            { index: true, element: <Index />},
            { path: "profile",
                children: [
                    { index: true, element: <ProfileView /> },
                ],
            },
            { path: "schedule",
                children: [
                    { index: true, element: <ScheduleView /> },
                    { path: ":date/:class_code", element: <AttendanceView /> },
                ],
            },
            { path: "inbox",
                children: [
                    { index: true, element: <InboxList /> },
                    { path: ":id", element: <InboxView /> },
                ],
            },
            { path: "checkin",
                children: [
                    { path: "history", element: <CheckInHistory /> },
                ],
            },
            { path: "homework",
                children: [
                    { index: true, element: <HomeworkList /> },
                    { path: "create", element: <HomeworkAddEdit /> },
                    { path: ":id", element: <HomeworkAddEdit /> },
                    { path: "student/:studentId/details/:homeworkId", element: <HomeworkStudent /> },
                ],
            },
        ],
    },
];

const router = createBrowserRouter(routes)

export default router;
